// extracted by mini-css-extract-plugin
export default {"pleaseLogin":"Home_pleaseLogin__xOhCi","welcome":"Home_welcome__nL+Jk","buttonsContainer":"Home_buttonsContainer__RGquI","homePageButtons":"Home_homePageButtons__D2aHt"};